import { colors } from 'Constants/Colors';

export const drawerBottomButton = {
  width: '80%',
  height: '50%',
  background: colors.GREEN,
};

export const typographyStyle = {
  marginLeft: '1rem',
  fontWeight: 'bold',
  fontSize: '1rem',
};

export const iconStyle = { color: colors.GRAY_SUBMIT };

export const acordionStyle = { display: 'flex', justifyContent: 'center' };

export default {
  drawerBottomButton,
  iconStyle,
  typographyStyle,
  acordionStyle,
};
